import { css } from '@emotion/react';
import { FeatureLocked } from '@frontend/empty-states#svg';
import { theme } from '@frontend/theme';
import { PrivateField } from './private-field';

export const PrivateFeature = () => {
  return (
    <div css={styles.privateFeatureWrapper}>
      <FeatureLocked style={{ maxWidth: 250, marginBottom: theme.spacing(4) }} />
      <PrivateField isCompact={false} textAlign='center' size='large' />
    </div>
  );
};

const styles = {
  privateFeatureWrapper: css`
    align-items: center;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding-top: ${theme.spacing(4)};
  `,
};
